import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { HardwareEdit } from './components/hardware-edit';

function initializeHardwareEdit(): void {
    const rootElement = document.getElementById('hardware-edit-root');
    if (!(rootElement instanceof HTMLElement)) {
        return;
    }

    const pageData = rootElement.dataset.page;
    if (typeof pageData !== 'string' || pageData.length === 0) {
        return;
    }

    const page = JSON.parse(pageData);
    createRoot(rootElement).render(<HardwareEdit page={page} />);
}

initializeHardwareEdit();
